import TemplateView from "../../TemplateView";

export default class TabHeaders extends TemplateView {
    templateHtml() {
        return "<div class='tabs'>" +
               "  <div class='details'><span class='tabText'><%=detailsTab%></span></div>" +
               "  <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" +
               "  <div class='managers'><span class='tabText'><%=managersTab%></span></div>" +
               "</div>"
    }

    afterRender() {
        this.$detailsTabHeader = this.find(".details");
        this.$assignedUsersTabHeader = this.find(".assignedUsers");
        this.$managersTabHeader = this.find(".managers");
        this.$assignedUsersTabTitle = this.$assignedUsersTabHeader.find(".tabText");
        this.$managersTabTitle = this.$managersTabHeader.find(".tabText");
    }

    messageKeys() {
        return {
            detailsTab: "project.edit_panel.tabs.details",
            assignedUsersTab: 'project.edit_panel.tabs.assigned_users',
            managersTab: 'project.edit_panel.tabs.managers'
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/TabHeaders.js